export const isEmptyObject = <T>(val: T): val is NonNullable<T> => {
  if (!val) return false
  // if (isArray(obj)) return obj.length == 0;
  for (const k in val) {
    return false
  }
  return true
}


/**
 * 判断是否包含非法字符
 * @param {any} str
 */
export const isAllowPost = (input: string) => {
  if (!input) return true;
  var invalidCharacters = ["<applet>",
    "<body>",
    "<embed>",
    "<frame>",
    "<script",
    "<frameset>",
    "<html>",
    "<iframe>",
    "<img",
    "<style>",
    "<layer>",
    "<link>",
    "<ilayer>",
    "<meta>",
    "<object>"];
  const tmp = input.toLowerCase();
  for (let i = 0; i < invalidCharacters.length; i++) {
    if (tmp.indexOf(invalidCharacters[i]) != -1) {
      return false;
    }
  }
  return true;
}